import { RoleTypeDictOption } from 'api/dict/params';
import {
  BusinessEntityWrapper,
  IntegrationObjectStatus,
  SupervisedObjectWrapper,
} from 'types/types';

export enum EnvironmentType {
  DEV = 'DEV',
  DEV_FORS = 'DEV_FORS',
  TEST = 'TEST',
  TEST_FORS = 'TEST_FORS',
  TEST2 = 'TEST2',
  TEST2_FORS = 'TEST2_FORS',
  DEMO = 'DEMO',
  HOTFIX = 'HOTFIX',
  PROD = 'PROD',
}

export type InitInfo = {
  build: string;
  version: string;
  urlAccounts: string;
  urlCerberus: string;
  environmentType: EnvironmentType;
};

export interface Permission {
  id: string;
  name: string;
  subPermissions: Permission[];
  text: string;
}

export interface PatentHolder {
  shortName: string;
  id: string;
}

export enum UserRoleName {
  PATENTEE = 'PATENTEE',
  VETERINARIAN = 'VETERINARIAN',
  APOTHECARY = 'APOTHECARY',
  CA_GALEN = 'CA_GALEN',
  CA_IRENA = 'CA_IRENA',
  VGNKI = 'VGNKI',
}

export interface UserRole {
  custom: boolean;
  id: string;
  name: UserRoleName;
  permissionSet: Permission[];
}

export interface UserData {
  authorities: Array<
    Permission & {
      authority: string;
      uuid: string[];
    }
  >;
  fio: string;
  firstName: string;
  id: string;
  lastName: string;
  login: string;
  middleName: string;
  patentHolders: PatentHolder[];
  customRole: UserRole;
  userRoleSet: UserRole[];
  patentee?: {
    id: string;
    confirmed: boolean;
    name: string;
    businessEntityLoadingStatus: IntegrationObjectStatus;
  };
  currentBusinessEntity?: BusinessEntityWrapper;
  currentSupervisedObject?: SupervisedObjectWrapper;
  supervisedObjects?: SupervisedObjectWrapper[];
  supervisedObjectRoleTypeList?: RoleTypeDictOption[];
  supervisedObjectClarification: boolean;
}

export interface UserDataContextType {
  userData: UserData | null;
  isUserDataLoading: boolean;
  initInfo: InitInfo | null;
  getUserData?: () => void;
}
